// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"ffa50bd3","133":"b0835045","453":"d855a71b","483":"51e9d1c1","567":"42503d71","589":"7435b73d","721":"66480c4a","761":"d8bc32f4","796":"5fbc6950","925":"de6bb80d","988":"2a599557"}[chunkId] + ".chunk.js";
};